import { render } from "./DocumentInspector.vue?vue&type=template&id=15268d0c&scoped=true"
import script from "./DocumentInspector.vue?vue&type=script&lang=js"
export * from "./DocumentInspector.vue?vue&type=script&lang=js"

import "./DocumentInspector.vue?vue&type=style&index=0&id=15268d0c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15268d0c"]])

export default __exports__